import { render } from "./InformacionGeneralComponent.vue?vue&type=template&id=f1380c62&scoped=true"
import script from "./InformacionGeneralComponent.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralComponent.vue?vue&type=script&lang=js"

import "./InformacionGeneralComponent.vue?vue&type=style&index=0&id=f1380c62&scoped=true&lang=css"
import "./InformacionGeneralComponent.vue?vue&type=style&index=1&id=f1380c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1380c62"]])

export default __exports__